<template>
    <div>

        <headline>
            Auslastung
            <span class="text-gray-500">{{ prevText }} - {{ nextText }}</span>
            <template slot="more">
                <button-secondary @click="load(prev)" class="mr-2">
                    <template slot="icon"><i class="fa fa-calendar-minus-o"></i></template>
                    Vorherige Woche
                </button-secondary>
                <button-secondary @click="load(next)">
                    <template slot="icon"><i class="fa fa-calendar-plus-o"></i></template>
                    Nächste Woche
                </button-secondary>
            </template>
        </headline>

        <select-menu
            class="mb-8"
            v-if="floor"
            v-model.number="floor"
            :text="floors.map(f => f.name)"
            :values="floors.map(f => f.id)"
        >
            Etage
        </select-menu>

        <navigation-heatmap class="mb-8" :items="desks.filter(desk => desk.floor_id === floor)"></navigation-heatmap>

        <tailwind-table :header="['Schreibtisch', 'Auslastung']">
            <tr v-for="item in desks.filter(desk => desk.floor_id === floor)">
                <td class="px-6 py-3">{{ item.name }}</td>
                <td class="px-6 py-3">{{ item.total * 100 }}%</td>
            </tr>
        </tailwind-table>
    </div>
</template>

<script>
import TailwindTable from "../components/UI/TailwindTable.vue";
import NavigationHeatmap from "../components/NavigationHeatmap.vue";
import SelectMenu from "../components/UI/SelectMenu.vue";
import Headline from "../components/UI/Headline.vue";
import ButtonSecondary from "../components/UI/ButtonSecondary.vue";
import subDays from "date-fns/subDays";

export default {
    name: "Heatmap",

    components: {
        ButtonSecondary,
        Headline,
        SelectMenu,
        NavigationHeatmap,
        TailwindTable
    },

    data: () => ({
        desks: [],
        floor: null,
        floors: [],
        next: null,
        prev: null,
        german: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    }),

    mounted() {
        this.load();
    },

    computed: {
        nextText() {
            if (next === null) {
                return '';
            }
            const next = subDays(new Date(this.next), 1);
            return `${this.german[next.getDay()]} ${next.getDate()}.${next.getMonth() + 1}`;
        },
        prevText() {
            if (prev === null) {
                return '';
            }
            const prev = new Date(this.prev);
            return `${this.german[prev.getDay()]} ${prev.getDate()}.${prev.getMonth() + 1}`;
        },
    },

    methods: {
        load(date = null) {
            this.$http.get('/admin/desk_statistics', {
                params: {
                    date: date,
                }
            }).then(response => {
                this.desks = response.data.data;
                if (this.floor === null) {
                    this.floor = this.desks.find(d => d.floor_id !== null).floor_id;
                }
                this.floors = response.data.floors;
                this.next = response.data.next;
                this.prev = response.data.prev;
            })
        }
    }

}
</script>

<style scoped>

</style>
